import clsx from "clsx";

import type { Pricing, PricingPeriodInfo } from "common/types";

function getPricingPeriodLabel({ period, period_unit }: PricingPeriodInfo) {
  if (period_unit === "month") {
    if (period === 1) {
      return "Monthly";
    }
    return `${period} months`;
  }
  return "Yearly";
}

interface PricingPeriodSelectorProps {
  pricingOptions: { addon: Pricing; plan: Pricing }[];
  value: PricingPeriodInfo | undefined;
  setValue: (newValue: PricingPeriodInfo) => void;
}

export default function PricingPeriodSelector({
  pricingOptions,
  value,
  setValue,
}: PricingPeriodSelectorProps) {
  return (
    <div className="flex p-0.75 rounded-2xl border border-black-200 bg-black-50 h-11.5 mb-6">
      {pricingOptions.map(({ plan: { period, period_unit } }) => {
        const pricingPeriodInfo = { period, period_unit };
        const isSelected =
          value && value.period === period && value.period_unit === period_unit;

        return (
          <button
            key={`${period}-${period_unit}`}
            type="button"
            onClick={() => setValue(pricingPeriodInfo)}
            className={clsx(
              "flex-1 rounded-xl text-button-sm",
              isSelected
                ? "bg-white shadow-[0_3px_6px_2px_rgba(17,24,39,0.10)]"
                : "hover:bg-black-100",
            )}
          >
            {getPricingPeriodLabel(pricingPeriodInfo)}
          </button>
        );
      })}
    </div>
  );
}
